import API from '../../API/endpoints';

export const SET_STATS = 'SET_STATS';
export const SET_STATS_LOADING = 'SET_STATS_LOADING';

export const setStats = (payload: object) => {
    return {
        type: SET_STATS,
        payload: payload,
    }
}

export const setStatsApiLoading = (payload: any) => {
    return {
        type: SET_STATS_LOADING,
        payload: payload,
    };
};

export const getStats = (history: any) => async (
    dispatch: any
) => {
    try {
        const reqValues = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
        }
        dispatch(setStatsApiLoading(true));
        fetch(API.dashboard(localStorage.getItem('orgId') || ''), reqValues)
            .then((result) => {
                if (result.status === 403) {
                    history.push({
                        pathname: '/',
                    })
                } else {
                    return result.json()
                }
            })
            .then((result) => {
                if (result.result) {
                    dispatch(setStats(result.result));
                    dispatch(setStatsApiLoading(false));
                }
            })
            .catch((error) => {
                dispatch(setStats({}))
                dispatch(setStatsApiLoading(false));
            })
    } catch (error) {
    }
}

